export const contentOptions = {
  default: {
    title: 'Os dados do cartão serão apagados',
    subtitle:
      'Para editar a forma de pagamento, você voltará para a etapa de escolha da forma de pagamento e os dados do cartão adicionados nesse pedido serão apagados.',
    primaryLabel: 'Editar pagamento',
    secondaryLabel: 'Voltar para revisão',
  },
  giftAndCreditCard: {
    title: 'Suas informações serão apagadas',
    subtitle:
      'Ao voltar para alterar seu pedido, sua escolha de brindes e dados do cartão serão apagados. Caso conquiste promoções você precisará selecionar novamente seus brindes e caso queira pagar com cartão, precisará preencher novamente os dados.',
    primaryLabel: 'Alterar pedido',
    secondaryLabel: 'Voltar para revisão',
  },
  gift: {
    title: 'Sua seleção de brindes será apagada',
    subtitle:
      'Ao voltar para alterar seu pedido, sua seleção de brindes será apagada. Caso conquiste promoções, você precisará selecionar os brindes novamente.',
    primaryLabel: 'Alterar pedido',
    secondaryLabel: 'Voltar para revisão',
  },
};
